<template>
    <div>
        <div class="row">
            <div class="col-12">

                <div class="row">
                    <div class="col-12 mt-2">
                        <div class="row">
                            <div class="col-md-12">

                                <MdTabList v-bind:TabList="tablist" v-bind:ShowTabList="false">
                                    <div class="tab-content tab-content-no-padding tab-content-custom-pill" id="pills-tabContent-custom">
                                        <div class="tab-pane fade show active" id="Claims" role="tabpanel">
                                            
                                            <MdTablePaginationClient
                                                v-bind:fields="fields"
                                                v-bind:items="items"
                                                v-bind:totalRows="totalRows"
                                                v-bind:refTable="refTable"
                                                v-bind:showMessageIsEmpty="this.items.length === 0 ? true : false"
                                                v-bind:currentPage="currentPage"
                                                v-bind:perPage="perPage"
                                                v-bind:SelectAll="UseSelectTableAll"
                                                v-bind:ShowDetails="false"
                                                v-bind:FieldsDate="FieldsDateArr"
                                                v-bind:pageOptions="pageOptions"
                                                v-bind:viewIconEvent="ViewIcon"
                                                v-bind:Error="Error"
                                                v-bind:Warning="Warning"
                                                :onRowSelected="onRowSelected"
                                                :onFiltered="onFiltered"
                                                :pageChanged="pageChanged"
                                                :RowClick="RowClicked"
                                                :perPageFunction="PerPageFunction"
                                            >
                                            </MdTablePaginationClient>

                                        </div>

                                        <div class="tab-pane fade show" id="Results" role="tabpanel">

                                            <TableClaimWarningError
                                                v-bind:fields="resultFields"
                                                v-bind:items="resultItems"
                                                v-bind:totalRows="totalRows"  
                                                v-bind:refTable="refResultTable"           
                                                v-bind:showMessageIsEmpty="this.resultItems.length === 0 ? true : false"
                                                v-bind:currentPage="currentPage"
                                                v-bind:perPage="perPage"                      
                                                v-bind:pageOptions="pageOptions" 
                                                :onRowSelected="onRowSelected" 
                                                :onFiltered="onFiltered"
                                                :pageChanged="pageChanged"
                                                :perPageFunction="PerPageFunction">
                                            </TableClaimWarningError>

                                        </div>
                                    </div>
                                </MdTabList>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import DBFunctions from '@/common/DBFunctions.js';
import ShowMessage from '@/components/messages/ShowMessage.js';
import Permission from '@/common/Permission';
import moment from 'moment';
import ClaimBatch from '@/services/claimbatch.service';

export default {
    name: 'ClaimBatchProcessing',
    props: {
        Items: Array
    },

    mixins: [ShowMessage, DBFunctions, Permission],
    
    data() {
        return {
            fields: [
                {
                    key: 'patientName',
                    sortable: true,
                    label: this.$t('Shared.PatientName'),
                    class: 'text-rigth'
                },
                {
                    key: 'selected',
                    sortable: true,
                    label: this.$t('Shared.selected'),
                    class: 'text-rigth hidden'
                },
                {
                    key: 'patientCode',
                    sortable: true,
                    label: this.$t('Shared.PatientCode'),
                    class: 'text-rigth'
                },
                {
                    key: 'errorList',
                    sortable: true,
                    label: this.$t('claimbatchList.colErrorList'),
                    class: 'text-rigth hidden'
                },
                {
                    key: 'warningList',
                    sortable: true,
                    label: this.$t('claimbatchList.colWarningList'),
                    class: 'text-rigth hidden'
                },
                {
                    key: 'dateFrom',
                    sortable: true,
                    label: this.$t('Shared.datefrom'),
                    class: 'text-rigth'
                },
                {
                    key: 'dateTo',
                    sortable: true,
                    label: this.$t('Shared.dateTo'),
                    class: 'text-rigth'
                },
                {
                    key: 'courseCode',
                    sortable: true,
                    label: this.$t('Shared.CPT'),
                    class: 'text-rigth'
                },
                {
                    key: 'unit',
                    sortable: true,
                    label: this.$t('Shared.Units'),
                    class: 'text-rigth'
                },
                {
                    key: 'totalCharges',
                    sortable: true,
                    label: this.$t('Shared.Charges'),
                    class: 'text-rigth',
                    formatter: value => {
                        return '$' + value;
                    }
                },
                {
                    key: 'hcpcsCode',
                    sortable: true,
                    label: this.$t('Shared.HCPCS'),
                    class: 'text-rigth'
                },
                {
                    key: 'modifier',
                    sortable: true,
                    label: this.$t('claimbatchList.colMod', { num: '1' }),
                    class: 'text-center'
                },
                {
                    key: 'modifier2',
                    sortable: true,
                    label: this.$t('claimbatchList.colMod', { num: '2' }),
                    class: 'text-center'
                },
                {
                    key: 'modifier3',
                    sortable: true,
                    label: this.$t('claimbatchList.colMod', { num: '3' }),
                    class: 'text-center'
                },
                {
                    key: 'modifier4',
                    sortable: true,
                    label: this.$t('claimbatchList.colMod', { num: '4' }),
                    class: 'text-center'
                },
                {
                    key: 'valueCode',
                    sortable: true,
                    label: this.$t('Shared.ValueCode'),
                    class: 'text-center'
                }
            ],
            resultFields: [  
                { key: 'description', sortable: true}       
            ],
            items: [],
            resultItems: [],
            tablist: [
                { title: 'Claims', link: '#Claims', active: true},
                { title: 'Results', link: '#Results'}
            ],
            totalRows: 0,
            perPage: 10,
            currentPage: 1,
            pageOptions: [5, 10, 15],
            refTable: 'selectableTableClaimBatch',
            refResultTable: 'selectableResultTableClaimBatch',
            UseSelectTableAll: false,
            FieldsDateArr: ['dateFrom', 'dateTo'],
        }
    },

    watch: {
        Items: {
            immediate: true, 
            
            handler(newVal) {
                this.items = newVal; 
            }
        }
    },
    
    methods: {

        ViewIcon() {
        },

        Error() {
        },

        Warning() {
        },

        onRowSelected() {
        },

        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },

        pageChanged() {
        },

        PerPageFunction(page) {
            this.perPage = page;
        },

        RowClicked() {
        },

        FormatDatesinItems() {
            var arr = this.items;
            arr.forEach(element => {
                element.dateFrom = moment(element.dateFrom).format();
                element.dateTo = moment(element.dateTo).format();
            });
            return arr;
        },

        ProcessBatch(validationOnly) {
            var List = this.FormatDatesinItems();

            this.items.forEach(function(element) {
                element.selected = true;
            });

            var param = {
                claimBatches: List,
                validationOnly: validationOnly 
            };
            ClaimBatch.ApplyBatch(param)
                .then(response => {
                    if (response.status == '200' && response.data) {
                        var data = response.data;

                        if (data.some(item => item.status !== "Successful")) {
                            this.showMessage(this.$tc('Msg.Error'), this.$t('claimbatchList.SomeErrorsOrWarnings'), 'error');
                        } else {
                            setTimeout(() =>
                                    this.$bvToast.toast(
                                        this.$t('Shared.SavedSuccessfully'),
                                        {
                                            title: this.$t('Msg.Success'),
                                            autoHideDelay: 5000,
                                            variant: 'success'
                                        }
                                    ),
                                50
                            );
                        }
                        this.SelectedRecords = 0;

                        this.resultItems = data.map(item => ({
                            description: item.validatedList?.[0] ?? item.warningList?.[0] ?? item.errorList?.[0]
                        }));
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

    },

    mounted() {
    }
};

</script>
